import React from 'react';

import ClientSection from '../components/ClientComponents/ClientSection';
import Testimonial from '../components/Testimonial/Testimonial';
import CallToAction from '../components/Misc/CallToAction';
import ProjectsSection from '../components/ProjectComponents/ProjectsSection';
import ServicesSection from '../components/ServicesComponents/ServicesSection';
import TextContent from '../components/TextContent/TextContent';
import ImageSlider from '../components/Misc/ImageSlider';
import Heading from '../components/Headers/Heading';
import RecentBlogPosts from '../components/BlogComponents/RecentBlogPosts';
import homeHeroImage from '../assets/images/index-2-header-img-1.webp';
import Art from '../components/Misc/Art';
import art from '../assets/images/art_3.png';
import { ServicesData } from '../Data/ServicesData';
import Footer from '../components/Misc/Footer';
import Button from '../components/Misc/Button';

const facilitySummaryData = [
    {
        heading: 'A Healing Environment',
        content: 'Our centre offers private and shared accommodations, therapy rooms, recreational areas, and 24/7 medical support.'
    }
];

const Home1 = () => {
    return (
        <>
            {/* Hero section from Home2 - start */}
            <div className="index-2-header position-relative">
                <div className="top-heading">
                    <div className="container">
                        <div className="hero-flex-row">
                            <div className="hero-heading-col">
                                <Heading 
                                    heading={<h1>Compassionate Rehabilitation & Recovery Support</h1>}
                                    headingClass="heading-very-large dark-1"
                                    paragraphClass="dark-2"
                                    paragraph={"A safe, structured, and medically supervised environment for overcoming substance use disorders and reclaiming your life."}
                                    headingColumn="col-12"
                                    paragraphColumn="col-12"
                                />
                            </div>
                            <div className="hero-buttons-col hero-hero-buttons-col">
                                <Button content="Get Help Now" link="/contact" type="1" />
                                <button 
                                  onClick={() => window.location.href='/programs'}
                                  style={{ background: '#181818', color: '#fff', border: 'none', padding: '1.9rem 5.1rem', fontSize: '1.6rem', fontWeight: 700, cursor: 'pointer', display: 'block', whiteSpace: 'nowrap' }}
                                >
                                  Our Programs
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ImageSlider
                images={[
                    {
                        image: homeHeroImage,
                        alt: 'Hero Image',
                    },
                    {
                        image: homeHeroImage,
                        alt: 'Hero Image',
                    },
                ]}
            />
            {/* Quote/Vision block - start */}
            <div className="quote-block" style={{background:'#000',padding:'32px 0',marginBottom:0}}>
                <div className="container text-center">
                    <div style={{
                        fontStyle:'italic',
                        fontSize:'1.5rem',
                        color:'#fff',
                        display:'inline-block',
                        textAlign:'left',
                        borderLeft:'4px solid #fff',
                        paddingLeft:'20px',
                        margin:0
                    }}>
                        "Our facility provides a secure, calm, and professionally managed environment designed to support recovery, reflection, and personal growth."
                    </div>
                </div>
            </div>
            {/* Quote/Vision block - end */}
            {/* Recent Activities section - start */}
            <RecentBlogPosts />
            {/* Recent Activities section - end */}
            <ServicesSection />
            <TextContent hideSecondaryButton={true} />
            {/* Hero section from Home2 - end */}

            {/* Projects section - start */}
            <div className="projects">
                <div className="projects-header-1" style={{ background: '#fff' }}>
                    <div className="container">
                        <Heading 
                            heading={<h2>Check some of our impact stories.</h2>}
                            headingClass="heading-very-large dark-1"
                            headingColumn="col-lg-9"
                        />
                    </div>
                </div>
                <div className="projects-wrapper">
                    <ProjectsSection numberOfStories={2} type="impact" />
                </div>
            </div>
            {/* Projects section - end */}

            {/* Facility Summary - start */}
            <TextContent 
                contentData={facilitySummaryData}
                headerTitle="Our Facility"
                footerHeading="Explore our healing environment"
                primaryButtonText="View Our Facility"
                primaryButtonLink="/facility"
                hideSecondaryButton={true}
                hideImage={true}
            />
            {/* Facility Summary - end */}

            {/* Testimonials section - start */}
            {/* <Testimonial /> */}
            {/* Testimonials section - end */}

            {/* Clients section - start */}
            {/* <ClientSection /> */}
            {/* Clients section - end */}

            {/* CTAs before footer - start */}
            <CallToAction 
                wrapperClass='bg-main'
                heading={
                    <>
                        Help is available.
                        <br />
                        Recovery starts with a conversation.
                    </>
                }
                buttonText="Contact Us Today"
                buttonLink="/contact"
                buttonType="2"
                artwork={<Art art={art} type={'4'} />}
            />
            {/* CTAs before footer - end */}
        </>
    );
};

export default Home1;
